import { Client } from 'openapi-fetch'

import type { paths } from '@kidzonet/ts-api-generator/clients/dashboard'

declare global {
    // eslint-disable-next-line vars-on-top
    var DashboardApiClient: Client<paths>
}

export const fetchPolicyList = async () => {
    const { data, error } = await globalThis.DashboardApiClient.GET('/v1/public/dashboard/policies')

    if (error) {
        throw error
    }
    const { items = [] } = data
    return items.map(
        ({ id, name, is_active }) => ({ id, name, isActive: is_active }),
    )
}

export const setPolicyList = async (policies: number[]) => {
    const { error } = await globalThis.DashboardApiClient.POST(
        '/v1/public/dashboard/policies/activate', {
            body: { policies },
        },
    )

    if (error) {
        throw error
    }
    return true
}

export const activateProtectionOn = async () => {
    const { data, error } = await globalThis.DashboardApiClient.POST(
        '/v1/public/dashboard/policies/protection', {
            body: { on: true, simple_ui: true },
        },
    )

    if (error) {
        throw error
    }
    if (data) {
        return true
    }
}

export const activateProtectionOff = async (simple_ui = true) => {
    const { data, error } = await globalThis.DashboardApiClient.POST(
        '/v1/public/dashboard/policies/protection', {
            body: { on: false, simple_ui },
        },
    )

    if (error) {
        throw error
    }
    if (data) {
        return true
    }
}
